import { Config } from "@config";
import { logError } from "@utils/sentry-error";
import type { HttpError } from "bm-ui-kit";
import { http } from "bm-ui-kit";
import dayjs from "dayjs";
import type {
	PersonalLoanScoringCalculatorFormFields,
	PersonalLoanScoringRequest,
	PersonalLoanScoringResponse,
} from "./types";

function searchParamsToRequest(searchParams: PersonalLoanScoringCalculatorFormFields): PersonalLoanScoringRequest {
	const {
		birthYear,
		incomeList,
		receiptBank: _1,
		lastIncome1,
		lastIncome2,
		lastIncome3,
		existingLoans,
		employmentType: _2,
		inKHR,
		...other
	} = searchParams;

	const existingLoansObject = {};
	existingLoans.forEach((loan) => {
		if (existingLoansObject[loan.loanType] > 0) {
			existingLoansObject[loan.loanType] += loan.debt;
		} else {
			existingLoansObject[loan.loanType] = loan.debt;
		}
	});
	const data = {
		...other,
		birthYear,
		existingLoans: existingLoansObject,
		inKHR,
		incomeList,
		pastMonthsSalaries: [lastIncome1, lastIncome2, lastIncome3],
		calculationDate: dayjs().format("YYYY-MM-DD"),
	};

	return data;
}

export async function calculate(searchParams: PersonalLoanScoringCalculatorFormFields): Promise<{
	request: PersonalLoanScoringRequest;
	results: PersonalLoanScoringResponse;
}> {
	const request: PersonalLoanScoringRequest = searchParamsToRequest(searchParams);

	return http
		.post(Config.getApiUrl("/api/public/personal-loans/scoring"), request)
		.then((results: PersonalLoanScoringResponse) => ({
			request,
			results,
		}))
		.catch((error: HttpError) => {
			logError(error);

			return {
				request,
				results: {
					messages: [error?.body],
					availableLoans: [],
				},
			};
		});
}
